import React, { useEffect, useRef, useState } from 'react';
import Categories from "./Categories";
import Subjects from "./Subjects";
import Filters from "./Filters";
import Buttons from "../components/buttons";
import { CardBody, Col, Container, Row } from "reactstrap";
import ResultTable from "./ResultTable";
import Report from "./Report";
import '../style.css'
import Notifications from "../../../views/Notifications";
import Descriptions from './Descriptions';

const Stepper = (props) => {
    const notifRef = useRef()
    const [currentStep, setCurrentSteps] = useState(props.step ? props.step : 1)
    const [selectedCategory, setSelectedCategory] = useState(props.category ? props.category : null)
    const [subject, setSubject] = useState(null)
    const [filters, setFilters] = useState({})
    const [tableData, setTableData] = useState(null)
    const [timestamp, setTimestamp] = useState(props.timestamp ? props.timestamp : 1)

    useEffect(() => {
        if (props.timestamp !== timestamp) {
            reset()
        }
    }, [props.timestamp])

    const nextPage = () => {
        setCurrentSteps(currentStep + 1)
    }
    const previousPage = () => {
        setCurrentSteps(currentStep - 1)
    }

    const reset = () => {
        setCurrentSteps(props.step ? props.step : 1)
    }

    const selectCategory = (id) => {
        setSelectedCategory(id)
        nextPage()
    }

    const selectSubject = (id) => {
        setSubject(id)
        setCurrentSteps(currentStep + 1)
    }

    const handleTableData = (data) => {
        setTableData(data)
        nextPage();
    }

    const handleSetFilters = (filterValues) => {
        setFilters(filterValues)
        nextPage()
    }
    const Comparison = () => {
        let id = JSON.parse(localStorage.getItem('Comparison'))
        if (id !== null) {
            if (id.length <= 3 && !id.includes(tableData.id)) {
                id.push(tableData.id)
                localStorage.setItem('Comparison', id)
            } else {
                notifRef?.current?.notify('rt')
            }
            localStorage.setItem('Comparison', JSON.stringify(id))
        } else {
            let newId = [tableData.id]
            localStorage.setItem('Comparison', JSON.stringify(newId))
        }

    }
    const Steps = () => {
        switch (currentStep) {
            case 1:
                return (
                    <Container>
                        <Row>

                            <Categories
                                onSubmit={nextPage}
                                onSelect={selectCategory}
                            />
                        </Row>
                    </Container>)
            case 2:
                return (
                    <Container>
                        <Row>
                            <Subjects
                                Category={selectedCategory}
                                onSubmit={nextPage}
                                previousPage={previousPage}
                                onSelect={selectSubject}
                            />
                        </Row>
                        {selectedCategory === 1 && (<Descriptions />)}
                    </Container>)
            case 3:
                return (
                    <Container>
                        <Row>
                            <Filters
                                filters={filters}
                                subject={subject}
                                category={selectedCategory}
                                onSetFilters={handleSetFilters}
                                previousPage={previousPage}
                            />
                        </Row>
                    </Container>
                )
            case 4:
                return (
                    <Container>
                        <Row>
                            <ResultTable
                                filters={filters}
                                subject={subject}
                                category={selectedCategory}
                                onSelect={handleTableData}
                            />
                        </Row>
                        <Row className="justify-content-center mt-1">
                            <Buttons
                                previousPage={previousPage} />
                        </Row>
                    </Container>
                )
            case 5:
                return (
                    <Container>
                        <Row>
                            <Report
                                onSubmit={nextPage}
                                tableData={tableData}
                                Comparison={Comparison}
                                previousPage={previousPage} />
                        </Row>
                        <Row className="justify-content-center ">
                            <Buttons
                                previousPage={previousPage} />
                        </Row>
                    </Container>)

        }


    }
    return (
        <>

            <Steps />


            <Col sm={12}>
                <Notifications ref={notifRef} color={4}
                    text={"شما مجاز به مقایسه 4 نتیجه می  باشید"}
                /> </Col>

        </>
    );
};

export default Stepper;